<template>
  <div class="my-refund-picker">
    <mt-popup
      v-model="isShow"
      position="bottom"
      popup-transition="popup-fade"
      style="width: 100%"
      :closeOnClickModal="false"
      v-clickoutside="closePopup"
    >
      <div class="m-refund-picker-title">
        <span>选择产品</span>
        <i class="m-refund-picker-close"></i>
      </div>
      <ul
        v-for="(item, index) in list"
        :key="index"
        class="m-refund-goods-list"
      >
        <li class="m-refund-goods-item">
          <div class="m-refund-goods-item-left">
            <img
              :src="
                item.isSelect
                  ? 'icon_check_pressed.png'
                  : 'icon_check_normal.png' | imagePath
              "
              alt
              @click="singleSelect(index)"
            />
          </div>
          <div class="m-refund-goods-item-right">
            <img
              class="m-refund-goods-goods-img"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
            <div class="m-refund-goods-goods-info">
              <span class="m-refund-goods-goods-name">{{ item.title }}</span>
              <p class="m-refund-goods-goods-spec">{{ item.item_key_name }}</p>
              <div class="m-refund-goods-goods-otp">
                <span class="m-refund-goods-goods-price">
                  <strong>￥{{ item.price }}</strong>
                </span>
                <el-input-number
                  style="width: 2rem"
                  :value="item.num"
                  :min="1"
                  :max="item.maxNum"
                  size="mini"
                  @change="handleChange($event, index)"
                ></el-input-number>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="m-refund-picker-goods-add-opt">
        <mt-button class="m-refund-picker-goods-button" @click="cancel"
          >取消</mt-button
        >
        <mt-button class="m-refund-picker-goods-button danger" @click="onSubmit"
          >提交</mt-button
        >
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  name: "MyRefundPicker",
  data() {
    return {};
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    list: [],
    order_id: 0,
  },
  computed: {
    order_goods() {
      const { list } = this;
      return Object.values(list)
        .filter((item) => item.isSelect == true)
        .map((item) => {
          //反向解析构
          let {
            agreement_price,
            discount_amount,
            goods_id,
            isSelect,
            is_virtual,
            item_id,
            item_key,
            item_key_name,
            maxNum,
            order_id,
            price,
            price_type,
            prom_amount,
            prom_price,
            settle_price,
            thumbnail,
            title,
            total_amount,
            total_num,
            ...obj
          } = item;
          return Object.assign(obj, {});
        });
    },
  },
  methods: {
    closePopup() {
      this.$emit("update:isShow", false);
    },
    cancel() {
      this.closePopup();
    },
    onSubmit() {
      const { order_id, order_goods } = this;
      const path = "mrefund";
      this.closePopup();
      setTimeout(() => {
        this.$router.push({ path, query: { order_id, order_goods:JSON.stringify(order_goods) } });
      }, 600);
    },
    handleChange(ev, index) {
      this.list[index].num = ev;
    },
    singleSelect() {},
  },
  mounted() {},
  watch: {},
};
</script>

<style>
.my-address-picker .mint-popup.mint-popup-bottom {
  padding: 0 !important;
}
.m-refund-goods-item-left {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
  padding: 0 0.2rem;
}

.m-refund-goods-item-left img {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
}
.m-refund-goods-goods-img {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.2rem;
}
.m-refund-goods-goods-info {
  flex: 1;
  padding-left: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.m-refund-goods-item-left {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
  padding: 0 0.2rem;
}

.m-refund-goods-item-left img {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
}
.m-refund-goods-item-right {
  display: flex;
  align-items: center;
}
.m-refund-goods-item {
  display: flex;
  padding: 0.2rem;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 0.2rem;
}
.m-refund-goods-goods-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: bold;
}
.m-refund-goods-item-tip {
  background-color: #e60012;
  color: #fff;
  border-radius: 4px;
  width: 120px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  margin-top: 0.1rem;
}
.m-refund-picker-goods-add-opt {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.m-refund-picker-goods-button {
  flex: 1;
  background: #000;
  color: #fff;
  border-radius: 0;
  padding: 0.1rem 0.4rem;
  display: block;
  margin: auto;
  font-size: 0.28rem;
}

.m-refund-picker-goods-button.danger {
  background: #f00;
  color: #fff !important;
}
.mint-toast.is-placemiddle {
  z-index: 999999;
}

.m-refund-goods-list {
  max-height: 6.4rem;
  overflow: hidden;
  overflow-y: scroll;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  margin-bottom: 1rem;
  margin-top: 0.2rem;
}
.m-refund-goods-goods-spec {
  color: #898989;
  margin-top: 0.1rem;
}
.m-refund-picker-title {
  display: block;
  width: 100%;
  text-align: center;
  padding-top: 0.2rem;
}

.m-refund-picker-title span {
  font-size: 0.3rem;
  font-weight: bold;
  display: block;
}
.m-refund-goods-goods-otp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyRefundPicker/index.vue